import { TranslatedTerms } from "../../globals/TranslatedTerms";
import { DefaultId } from "../../shared/Globals";
import { TranslationDictionary } from "../../shared/Language";
import { ProjectStatus, ProjectStatusLabel } from "../../shared/ProjectStatus";


export const ProjectDictionary: TranslationDictionary = {
    [TranslatedTerms.FUNDING_TARGET]: {
        [DefaultId]: "Funding target",
        "da": "Funding mål"
    },
    [TranslatedTerms.INTEREST_RATE_PR_Y]: {
        [DefaultId]: "Interest/year",
        "da": "Rente p.a."
    },
    [TranslatedTerms.INTEREST_RATE]: {
        [DefaultId]: "Interest",
        "da": "Rente"
    },
    [TranslatedTerms.DURATION]: {
        [DefaultId]: "Duration",
        "da": "Løbetid"
    },
    [TranslatedTerms.PRINCIPAL]: {
        [DefaultId]: "Principal",
        "da": "Hovedstol"
    },
    [TranslatedTerms.COVER]: {
        [DefaultId]: "Coverage",
        "da": "Overdækningsgrad"
    },
    [TranslatedTerms.CURRENT_FUNDING]: {
        [DefaultId]: "Current funding",
        "da": "Rejst beløb"
    },
    [TranslatedTerms.PROJECT_SIZE]: {
        [DefaultId]: "Project size",
        "da": "Projektstørrelse"
    },
    [TranslatedTerms.MIN_INVESTMENT]: {
        [DefaultId]: "Min. deposit",
        "da": "Min. indskud"
    },
    [TranslatedTerms.MTH]: {
        [DefaultId]: "Mth",
        "da": "Mdr"
    },
    [TranslatedTerms.A_GOOD_INVESTMENT]: {
        [DefaultId]: "A good investment",
        "da": "En god investering"
    },
    [TranslatedTerms.INVEST_NOW]: {
        [DefaultId]: "Invest now",
        "da": "Invester nu"
    },
    [TranslatedTerms.PROJECT_COMMING_SOON]: {
        [DefaultId]: "Coming soon",
        "da": "Kommer snart"
    },
    [TranslatedTerms.PROJECT_OPEN_FOR_INVESTMENT]: {
        [DefaultId]: "Invest",
        "da": "Investér"
    },
    [TranslatedTerms.PROJECT_WAITING_FOR_START]: {
        [DefaultId]: "Waiting for start",
        "da": "Afventer start"
    },
    [TranslatedTerms.PROJECT_IN_PROGRESS]: {
        [DefaultId]: "Project in progress",
        "da": "Projekt i gang"
    },
    [TranslatedTerms.PROJECTS_IN_PROGRESS]: {
        [DefaultId]: "Projects in progress",
        "da": "Projekter i gang"
    },
    [TranslatedTerms.PROJECT_IN_COMPLETED]: {
        [DefaultId]: "Project finished",
        "da": "Projekt færdigt"
    },
    [TranslatedTerms.PROJECTS_IN_COMPLETED]: {
        [DefaultId]: "Finished projects",
        "da": "Færdige projekter"
    },
    [ProjectStatusLabel.PROJECT_FAILED]: {
        [DefaultId]: "Finished with loss",
        "da": "Afsluttet med tab"
    },
    [ProjectStatusLabel.PROJECT_FAIL_IN_PROCESS]: {
        [DefaultId]: "In liquidation",
        "da": "Under afvikling"
    },
    [TranslatedTerms.INVESTMENT]: {
        [DefaultId]: "Investment",
        "da": "Investeringen"
    },
    [TranslatedTerms.INVESTMENT_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "Crowdlending is a method where private investors can lend their assets to investment projects in order to earn an interest gain. \nAt Fundbricks.com, your assets are lent to property developers who have solid Danish real estate projects with large financial coverage and who need financing in the construction period to be able to realize the projects. \nThe real estate developer gets the opportunity to realize his project and secure a profit - and the investors get a high interest rate for a loan in a short period. ",
        "da": "Crowdlending er en metode hvor private investorer kan udlåne sin formue til investeringsprojekter med henblik på at optjene en rentegevinst.\nHos Fundbricks.com udlånes din formue til ejendomsudviklere, som har solide danske ejendomsprojekter med stor økonomisk overdækning, og som har behov for finansiering i byggeperioden for at kunne realisere projekterne.\nEjendomsudvikleren får mulighed for at realisere sit projekt og sikre sig en fortjeneste - og investorerne får en høj rente for et udlån i en kort periode.",
    },
    [TranslatedTerms.INVESTMENT_PROJECT_LABEL_DOCUMENT]: {
        [DefaultId]: "At Fundbricks.com, we highly value openness and clarity throughout your investment journey. Therefore, we ensure that we carefully document and continuously update all aspects of the projects in the associated documents. It is our goal to ensure that you, as an investor, are always well-informed and confident in your investment decisions",
        "da": "Hos Fundbricks.com vægter vi åbenhed og klarhed højt i hele din investeringsrejse. Derfor sørger vi for omhyggeligt at dokumentere og kontinuerligt opdatere alle aspekter af projekterne i de tilhørende dokumenter. Det er vores mål at sikre, at du som investor altid er velinformeret og tryg ved dine investeringsbeslutninger.",
    },
    [TranslatedTerms.BUILDING_DEVELOPER]: {
        [DefaultId]: "Developer",
        "da": "Ejendomsudvikler"
    },
    [TranslatedTerms.BUILDING_DEVELOPER_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "The real estate developer is the person / company who is responsible for the individual real estate project and who offers the loan to the investors on Fundbricks.com. \nThe real estate developer typically has a plot (or property) on which private homes can be built or which can be renovated / converted. \n\nThere are the bank will typically contribute X%, the property developer can contribute Y% and the remaining Z% of financing will be raised through Fundbricks.com. \n\nIt is solely the property developer and its management, who are fully responsible for the investment, marketing and offer. ",
        "da": "Ejendomsudvikler er personen/virksomheden som står for det enkelte ejendomsprojekt og som udbyder lånet til investorerne på Fundbricks.com.\nEjendomsudvikleren har typisk en grund (eller ejendom) hvorpå der kan bygges privatboliger eller som kan renoveres/omdannes.\n\nDer findes en lang række solide danske ejendomsprojekter, som ikke kan gennemføres på grund af manglende finansiering. Banken vil typisk være med på X%, ejendomsudvikleren kan selve bidrage med Y% og de resterende Z% af finansiering rejses gennem Fundbricks.com.\n\nDet er udelukkende ejendomsudvikleren og dennes ledelse, som i sin helhed har ansvaret for investeringen, markedsføringen og tilbuddet.",
    },
    [TranslatedTerms.PROJECT_COMPANY]: {
        [DefaultId]: "Projectcompany",
        "da": "Projektselskab"
    },
    [TranslatedTerms.PROJECT_COMPANY_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "The project company is the legal entity that owns the building plot / property (or the building right thereof), has the construction agreement with those who are to build the homes and who is legally responsible for the implementation of the property project. \nIt is also the project company that has a loan agreement with the bank and it is the project company which is the legal party with whom the investors enter into a loan agreement. \nThe project company is typically 100% owned by the property developer. ",
        "da": "Projektselskabet er den juridiske enhed som ejer byggegrunden/ejendommen (eller byggeretten dertil), har entrepriseaftalen med dem som skal bygge boligerne og som er juridisk ansvarlig for gennemførsel af ejendomsprojektet.\nDet er også projektselskabet som har evt. låneaftale med banken og det er projektselskabet der er den juridiske part som investorerne indgår låneaftale med.\nProjektselskabet er typisk ejet 100% af ejendomsudvikleren.",
    },
    [TranslatedTerms.DEPOSIT_ACCOUNT]: {
        [DefaultId]: "Deposit account",
        "da": "Deponeringskonto"
    },
    [TranslatedTerms.DEPOSIT_ACCOUNT_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "The deposit account is our most important management tool to ensure that your money is used to realize the real estate project. Here, all deposits from crowd investors and possibly bank will be deposited and paid out directly to the craftsmen / contractor as the construction progresses. It is also through this account that your deposit and future interest gain will be paid out from. ",
        "da": "Deponeringskontoen er vores vigtigste styringsredskab til at sikre, at dine penge bruges til at realisere ejendomsprojektet. Her vil alle indskud fra crowdinvestorer og evt. bank blive deponeret og løbende udbetalt direkte til håndværkerne/entreprenøren som byggeriet skrider fremad. Det er også via denne konto at dit indskud og kommende rentegevinst vil blive udbetalt fra."
    },
    [TranslatedTerms.CROWDINVESTOR]: {
        [DefaultId]: "Crowdinvestor",
        "da": "Crowdinvestor"
    },
    [TranslatedTerms.CROWDINVESTOR_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "Crowd investors are private / institutional investors who participate in lending to one or more real estate projects. \nA Crowdinvestor is no different from a regular investor, but simply an expression of a number of investors participating in the individual project. \nFundbricks .com has built a structure where the goal is to create maximum transparency and full clarity throughout the process. \nInvestor clearing is done electronically directly via our platform - Here, name, address and identity are verified as a condition for the validity of the loan agreement. ",
        "da": "Crowdinvestorer er private/institutionelle investorer som deltager med udlån til et eller flere ejendomsprojekter.\nEn “crowdinvestor” er ikke anderledes end en “almindelig investor”, men blot et udtryk for at der deltager en række investorer i det enkelte projekt.\nFundbricks.com har opbygget en struktur hvor målet er at skabe maksimal transparens og fuld klarhed over hele processen.\nInvestorclearing sker elektronisk direkte via vores platform - Her bliver navn, adresse og identitet verificeret som en betingelse for låneaftalens gyldighed.",
    },
    [TranslatedTerms.BANK_FINANCEING]: {
        [DefaultId]: "Bank / Financing",
        "da": "Bank / Finansiering"
    },
    [TranslatedTerms.BANK_FINANCEING_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "The bank typically has two functions in a real estate project; 1) financing / lending and 2) deposit account. \nThe deposit account in the bank is created based on instructions from Fundbricks.com and with a wording that ensures that payments can only be made with the approval of an external independent building expert. , and that Fundbricks.com can only deduct its capital brokerage fee. ",
        "da": "Banken har typisk to funktioner i et ejendomsprojekt; 1) finansiering/långivning og 2) deponeringskonto.\nDeponeringskontoen i banken bliver oprettet ud fra anvisninger fra Fundbricks.com og med en ordlyd som sikrer at udbetalinger kun kan ske med godkendelse fra ekstern uvildig byggesagkyndig, og at Fundbricks.com kun kan trække sit kapitalformidlings honorar.",
    },

    [TranslatedTerms.FUNDBRICKS_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "The capital brokerage fee fee for Fundbricks.com is the payment we receive when the money for the individual property project is raised through the platform.",
        "da": "Kapitalformidlings honorar til Fundbricks.com er den betaling som vi får når pengene til det enkelte ejendomsprojekt er rejst gennem platformen.\nHvis fundingmålet for et projekt ikke nås inden deadline, bliver alle indbetalinger tilbageført og Fundbricks.com optjener ikke Kapitalformidlings honorar.",
    },
    [TranslatedTerms.PROJECT_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "The property project is a short description of what is to happen to the individual plot / property, what is to be built and where it is geographically located.",
        "da": "Ejendomsprojektet er en kort beskrivelse af hvad der skal ske med den enkelte grund/ejendom, hvad der skal bygges og hvor det geografisk er placeret.",
    },
    [TranslatedTerms.CONSTRUCTION_EXPERT]: {
        [DefaultId]: "Construction expert",
        "da": "Byggesagkyndig"
    },
    [TranslatedTerms.CONSTRUCTION_EXPERT_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "The independent construction expert is - together with the deposit account - an important element to manage and ensure that the construction is carried out correctly and on time, that crucial milestones are achieved and that payments are only made when milestones in the construction are achieved. \nThe construction expert will visit the property / the construction site continuously throughout the construction period and will validate / check that the construction is carried out in accordance with current industry standards and in proper quality. ",
        "da": "Den uvildige byggesagkyndig er - sammen med deponeringskontoen - et vigtigt element for at styre og sikre at byggeriet bliver udført korrekt og rettidigt, at afgørende milepæle bliver opnået samt at udbetalinger kun sker når milepæle i byggeriet er opnået.\nDen byggesagkyndige vil besøge ejendommen/byggepladsen løbende gennem byggeperioden og vil validere/kontrollere at byggeriet udføres i henhold til gældende branchestandarder samt i behørig kvalitet.",
    },
    [TranslatedTerms.SALES_PERIOD]: {
        [DefaultId]: "Salesperiod",
        "da": "Salgsperiode"
    },

    [TranslatedTerms.SALES_PERIOD_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "In order for a property project to be approved for Fundbricks.com, there must be independent estimates of the sale price of the completed property, to make it probable that the expected sale price will be at least 20% greater than the total construction and financing costs. \nAn independent assessment is while providing an estimate of the expected sales period. ",
        "da": "For at et ejendomsprojekt kan godkendes til Fundbricks.com, skal der være uvildige vurderinger af salgsprisen for den færdigbyggede ejendom, for at sandsynliggøre at den forventede salgspris vil være minimum 20% større end de samlede bygge- og finanseringsomkostninger. \nEn uvildig vurdering er samtidig med til at give et estimat for den forventede salgsperiode.",
    },
    [TranslatedTerms.RETURN_PAYMENT]: {
        [DefaultId]: "Return payment",
        "da": "Tilbagebetaling"
    },
    [TranslatedTerms.RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "The sale price from the sale of the property is paid into the blocked deposit account. \nFrom here, repayment is made to the bank and investors. \nExcess proceeds are subsequently released to the property developer. \nReal estate projects are subject to VAT and VAT from the sale price is paid later to SKAT.",
        "da": "Salgssummen fra salg af ejendommen indbetales på den spærrede deponeringskonto. \nHerfra sker tilbagebetaling til bank og investorer. \nOverskydende provenu frigives efterfølgende til ejendomsudvikleren.\nEjendomsprojekter er momspligtige og moms fra salgssummen indbetales senere til SKAT.",
    },
    [TranslatedTerms.BANK_RETURN_PAYMENT]: {
        [DefaultId]: "Bank repayment",
        "da": "Bank indfries"
    },
    [TranslatedTerms.BANK_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "Bank loans and accrued bank interest are the first to be redeemed when the sale price from the sale has been paid into the deposit account.",
        "da": "Banklån og tilskrevne bankrenter er det første som indfries når salgssummen fra salget er indbetalt på deponeringskontoen."
    },
    [TranslatedTerms.CROWDINVESTOR_RETURN_PAYMENT]: {
        [DefaultId]: "Crowdinvestor repayment",
        "da": "Crowdinvestor indfries"
    },
    [TranslatedTerms.CROWDINVESTOR_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "Crowd investors and their accrued interest are next as redeemed when the sale price from the sale has been paid into the escrow account.",
        "da": "Crowdinvestorer og disses tilskrevne renter er det næste som som indfriet, når salgssummen fra salget er indbetalt på deponeringskontoen.",
    },

    [TranslatedTerms.DEVELOPER_RETURN_PAYMENT]: {
        [DefaultId]: "Developer repayment",
        "da": "Udvikler får resten"
    },
    [TranslatedTerms.DEVELOPER_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "When the bank and crowd investors are fully redeemed, excess residual proceeds from the escrow account will be released to the property developer.",
        "da": "Når bank og crowdinvestorer er fuld indfriet, frigives overskydende restprovenu fra deponeringskontoen til ejendomsudvikleren.\nHerfra er det ejendomsudviklerens opgave af afholde evt. andre omkostninger relateret til projektet, og er fra dette tidspunkt både bank, crowdinvestorer og Fundbricks.com uvedkommende.",
    },
    [TranslatedTerms.ECONOMY]: {
        [DefaultId]: "Economy",
        "da": "Økonomi"
    },
    [TranslatedTerms.ECONOMY_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "A comprehensive overview of coverage, assessment of sales price, funding targets, construction costs and miscellaneous costs.",
        "da": "En samlet oversigt over overdækning, vurdering af salgspris, fundingmål, byggeomkostninger samt diverse omkostninger.",
    },
    [TranslatedTerms.RISK]: {
        [DefaultId]: "Risici",
        "da": "Risici"
    },
    [TranslatedTerms.RISK_PROJECT_LABEL_DESCRIPTION]: {
        [DefaultId]: "Description of project-specific risks that an investor should be aware of. \nInvestment and lending always include a risk.",
        "da": "Beskrivelse af projektspecifikke risici som man som investor bør være opmærksom på.\nInvestering og udlån indbefatter altid en risiko.",
    },
    [TranslatedTerms.OPEN_DOCUMENT]: {
        [DefaultId]: "Open document",
        "da": "Åben dokument"
    },
    [TranslatedTerms.LATEST_VERSION]: {
        [DefaultId]: "Latest version",
        "da": "Seneste version"
    },
    [TranslatedTerms.DOCUMENTS]: {
        [DefaultId]: "Documents",
        "da": "Dokumenter"
    }
}